export default __webpack_public_path__ + "static/media/card4.c30bb0e0.png";